module.exports = __webpack_public_path__ + "img/MX.4330c279.png";